import dayjs from "dayjs";
import { defaultRtn, DateTimeType, RtnType } from '../declareTypes';

/** 日期时间处理 */
const dateHandle = async () => { };

/**
 * 获取时间戳
 * @param dateStr 日期，'2022-10-1 00:00:00'，不输入为当前时间
 * @returns 时间戳13位，毫秒/秒
 */
dateHandle.getTimestamp = (dateStr?: string): string => {
    /** 当前时间戳 */
    const timeStamp = dayjs(dateStr).valueOf().toString();
    return timeStamp;
};

/**
 * UTC时间转换为本地时间
 * @param utc UTC时间
 */
dateHandle.utcDateToLocalDate = (utc: any): RtnType => {
    const rtn = defaultRtn();
    try {
        let date1 = new Date();
        let offsetMinute = date1.getTimezoneOffset();
        let offsetHours = offsetMinute / 60;
        let date2 = new Date(utc);
        date2.setHours(date2.getHours() - offsetHours);
        rtn.success = true;
        rtn.data = date2;
    }
    catch (error: any) {
        rtn.message = '错误！';
        if (error) {
            const { message } = error;
            rtn.message = `${rtn.message}${message}`;
        }
    }
    return rtn;
};

/**
 * 获取当前日期时间
 * @param dateTime ? 返回的日期时间形式：dateTime:日期时间(默认)；timeStamp:时间戳；
 * date:日期；time:时间；year:年份；month:月份；day:日；hour:小时；minute:分钟；second:秒；
 * @returns 返回日期字符串
 */
dateHandle.getToday = (dateTime?: DateTimeType): RtnType => {
    const rtn = defaultRtn();
    try {
        let res;
        switch (dateTime) {
            case 'TIMESTAMP':
                res = dayjs().unix().toString();
                break;
            case 'DATETIME':
                res = dayjs().format('YYYY-MM-DD HH:mm:ss');
                break;
            case 'DATE':
                res = dayjs().format('YYYY-MM-DD');
                break;
            case 'TIME':
                res = dayjs().format('HH:mm:ss');
                break;
            case 'YEAR':
                res = dayjs().format('YYYY');
                break;
            case 'MONTH':
                res = dayjs().format('MM');
                break;
            case 'DAY':
                res = dayjs().format('DD');
                break;
            case 'HOUR':
                res = dayjs().format('HH');
                break;
            case 'MINUTE':
                res = dayjs().format('mm');
                break;
            case 'SECOND':
                res = dayjs().format('ss');
                break;
            default:
                res = dayjs().format('YYYY-MM-DD HH:mm:ss');
                break;
        }
        rtn.success = true;
        rtn.data = res;
    }
    catch (error: any) {
        rtn.message = '错误！';
        if (error) {
            const { message } = error;
            rtn.message = `错误！${message}`;
        }
    }
    return rtn;
};

/**
 * 14位字符串转时间格式
 * @param timeStr 14位时间，例如：20190703091000
 * @returns 转换格式，例如：yyyy-MM-dd hh:mm:ss
 */
dateHandle.exchangeTimeFormat = (timeStr: string): RtnType => {
    const rtn = defaultRtn();
    try {
        //去除特殊符号
        timeStr = timeStr.replace(/[&\|\\\*^%$#@\-]/g, "");
        var len = timeStr.length;
        if (len > 14) {
            timeStr = timeStr.substring(0, 14);
        } else {
            var diff = 14 - len;
            var addZeros = "";
            for (var i = 0; i < diff; i++) {
                addZeros += "0";
            }
            timeStr += addZeros;
        }
        //正则转换时间格式
        var regExp = /^(\d{4})(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})$/;
        var formatTime = '$1/$2/$3 $4:$5:$6';
        timeStr = timeStr != null && timeStr != "" && timeStr.length == 14 ? timeStr.replace(regExp, formatTime) : timeStr;
        rtn.success = true;
        rtn.data = timeStr;
    }
    catch (error: any) {
        rtn.message = '错误！';
        if (error) {
            const { message } = error;
            rtn.message = `错误！${message}`;
        }
    }
    return rtn;
};

/**
 * 严格判断字符串是否为日期格式，避免纯数字被误判
 * @param value 待判断的值
 * @returns 是否为日期字符串
 */
dateHandle.isStrictDateString = (value: unknown): boolean => {
    if (typeof value !== 'string') return false;
    // 仅当字符串符合常见的日期时间分隔符格式时才视为日期
    const patterns = [
        /^\d{4}-\d{2}-\d{2}$/,                   // 2026-01-01
        /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}/,  // ISO 字符串带时间
        /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/   // 常用日期时间格式
    ];
    return patterns.some(p => p.test(value)) && dayjs(value).isValid();
};

export default dateHandle;

